<template>
  <ElInputWrapper>
    <FlexLayout align="start" :gap="12">
      <BaseDataSelect
        :value.sync="selectedField"
        class="flex-shrink-0"
        :filterable="false"
        :dataList="displayFieldOptions"
        style="width: 340px;"
        labelKey="name"
        valueKey="key"
        placeholder="選擇搜尋欄位"
        @change="onFieldChange"
        @clear="onContextClear"
      />

      <FlexLayout align="center" :gap="8">
        <template v-if="showFieldType === 'birthday'">
          <!-- <el-date-picker
            v-model="contextModel"
            type="date"
            placeholder="請選擇生日"
            @change="onContextChange"
          /> -->
          <MonthSelect
            style="width: 340px;"
            :model.sync="contextModel"
            @change="onContextChange"
            @clear="onContextClear"
          />
        </template>

        <template v-if="showFieldType === 'gender'">
          <BaseDataSelect
            :value.sync="contextModel"
            style="width: 340px;"
            labelKey="label"
            valueKey="value"
            placeholder="請選擇性別"
            :filterable="false"
            :dataList="[
              {label: '男', value: 'male'},
              {label: '女', value: 'female'}
            ]"
            @change="onContextChange"
            @clear="onContextClear"
          />
        </template>
        <template v-if="showFieldType === 'email'">
          <SearchTextInput
            :value.sync="contextModel"
            style="width: 340px;"
            placeholder="請輸入 Email"
            @update="onContextChange"
            @clear="onContextClear"
          />
        </template>
        <!-- 地址 -->
        <template v-if="showFieldType === 'address'">
          <SearchTextInput
            :value.sync="contextModel"
            style="width: 340px;"
            placeholder="請輸入地址"
            @update="onContextChange"
            @clear="onContextClear"
          />
        </template>
        <!-- 單選 -->
        <template v-if="showFieldType === 'radio'">
          <BaseDataSelect
            :value.sync="contextModel"
            style="width: 340px;"
            label-key="label"
            value-key="value"
            :filterable="false"
            :dataList="map(selectedField.enum, (item) => ({
              label: item,
              value: item
            }))"
            @change="onContextChange"
            @clear="onContextClear"
          />
        </template>
        <!-- 多選 -->
        <template v-if="showFieldType === 'checkbox'">
          <BaseDataSelect
            :value.sync="contextModel"
            style="width: 340px;"
            multiple
            :filterable="false"
            label-key="label"
            value-key="value"
            :dataList="map(selectedField.enum, (item) => ({
              label: item,
              value: item
            }))"
            @change="onContextChange"
            @clear="onContextClear"
          />
        </template>
        <!-- 單選/多選 - 含子欄位 (父子下拉，皆為單選) -->
        <template v-if="showFieldType === 'radioSubField' || showFieldType === 'checkboxSubField'">
          <FlexLayout align="center" :gap="8" class="flex-wrap">
            <BaseDataSelect
              :value.sync="contextModel.parentValue"
              :dataList="parentOptionsList"
              style="width: 340px"
              label-key="label"
              value-key="value"
              obj-key="value"
              placeholder="請選擇"
              :filterable="false"
              @change="onParentChange"
              @clear="onParentClear"
            />

            <BaseDataSelect
              :value.sync="contextModel.childValue"
              :dataList="childOptionsList"
              style="width: 340px"
              label-key="label"
              value-key="value"
              obj-key="value"
              placeholder="請選擇"
              :filterable="false"
              :disabled="!contextModel.parentValue"
              @change="onContextChange"
              @clear="onChildClear"
            />
          </FlexLayout>
        </template>
        <!-- 簡答 -->
        <template v-if="showFieldType === 'text'">
          <SearchTextInput
            style="width: 340px;"
            :value.sync="contextModel"
            placeholder="請輸入文字"
            @update="onContextChange"
            @clear="onContextClear"
          />
        </template>
        <!-- 詳答 -->
        <template v-if="showFieldType === 'richtext'">
          <SearchTextInput
            style="width: 340px;"
            :value.sync="contextModel"
            placeholder="請輸入文字"
            @update="onContextChange"
            @clear="onContextClear"
          />
        </template>
        <!-- LINE 好友名稱 -->
        <template v-if="showFieldType === 'lineDisplayName'">
          <SearchTextInput
            style="width: 340px;"
            :value.sync="contextModel"
            placeholder="請輸入 LINE 好友名稱"
            @update="onContextChange"
            @clear="onContextClear"
          />
        </template>
      </FlexLayout>
    </FlexLayout>
  </ElInputWrapper>
</template>

<script>
import store from '@/store'
import { get, map, includes, filter, isArray, join, isObject } from 'lodash'
import { computed, defineComponent, nextTick, ref } from 'vue'
import BaseDataSelect from './BaseDataSelect.vue'
import SearchTextInput from '../Input/SearchTextInput.vue'
import MonthSelect from './MonthSelect.vue'
import ElInputWrapper from '../ElInputWrapper.vue'

export default defineComponent({
  name: 'CustomUserInfoFieldsSelect',
  components: {
    MonthSelect,
    BaseDataSelect,
    SearchTextInput,
    ElInputWrapper,
  },
  setup (props, { emit }) {
    const selectedField = ref(null)
    const showFieldType = ref(null)
    const contextModel = ref(null)
    const userRegisterConfig = computed(() => get(store.state, 'org.userRegisterConfig'))

    const displayFieldOptions = computed(() => {
      const customFields = map(filter(userRegisterConfig.value, (item) => {
        return !includes(['restrictedImage', 'name'], item.type)
      }), (field) => {
        return {
          ...field,
          name: field.isBase ? field.name : `自訂 - ${field.name}`,
        }
      })

      // 新增 LINE 好友名稱選項
      const lineDisplayNameOption = {
        key: 'lineDisplayName',
        name: 'LINE 好友名稱',
        type: 'lineDisplayName',
        isBase: true,
      }

      return [...customFields, lineDisplayNameOption]
    })

    const parentOptionsList = computed(() => {
      if (!selectedField.value || !selectedField.value.subFieldOptions) return []
      return map(selectedField.value.subFieldOptions, (g) => ({ label: g.parentValue, value: g.parentValue }))
    })

    const childOptionsList = computed(() => {
      if (!selectedField.value || !selectedField.value.subFieldOptions) return []
      const parent = get(contextModel.value, 'parentValue')
      if (!parent) return []
      const group = selectedField.value.subFieldOptions.find((g) => g.parentValue === parent)
      return map(get(group, 'childOptions', []), (c) => ({ label: c, value: c }))
    })

    const onFieldChange = async (field) => {
      if (field.type === 'checkbox') {
        contextModel.value = []
      } else if (field.type === 'radioSubField' || field.type === 'checkboxSubField') {
        // initialize as object with parentValue and childValue
        contextModel.value = { parentValue: null, childValue: null }
      } else {
        contextModel.value = null
      }
      await nextTick()
      showFieldType.value = field.type
    }

    const onContextChange = () => {
      const fieldKey = get(selectedField.value, 'key', null)

      // 因為 datePicker 沒有 clear 事件，所以只能判斷 contextModel 是否沒資料來代表 clear
      if (fieldKey === 'birthday') {
        if (!contextModel.value) {
          emit('clear')
          return
        }
      }

      // handle subField types which expect { parentValue, childValue }
      if (selectedField.value && ['radioSubField', 'checkboxSubField'].includes(selectedField.value.type)) {
        const parent = get(contextModel.value, 'parentValue')
        const child = get(contextModel.value, 'childValue')
        if (!parent && !child) {
          emit('clear')
          return
        }

        emit('change', {
          field: selectedField.value,
          contextValue: {
            parentValue: parent,
            childValue: child,
          },
        })
        return
      }

      let contextValue
      if (isArray(contextModel.value)) {
        contextValue = join(map(contextModel.value, 'value'), ',')
      } else if (isObject(contextModel.value)) {
        contextValue = get(contextModel.value, 'value', contextModel.value)
      } else {
        contextValue = contextModel.value
      }

      emit('change', {
        field: selectedField.value,
        contextValue,
      })
    }

    const onContextClear = () => {
      console.log('onContextClear')
      emit('clear')
    }

    const onParentChange = (val) => {
      // reset child when parent changed
      if (!contextModel.value) contextModel.value = {}
      contextModel.value.parentValue = val
      contextModel.value.childValue = null
    }

    const onParentClear = () => {
      contextModel.value.parentValue = null
      contextModel.value.childValue = null
      emit('clear')
    }

    const onChildClear = () => {
      contextModel.value.childValue = null
      emit('clear')
    }

    return {
      selectedField,
      contextModel,
      onFieldChange,
      displayFieldOptions,
      showFieldType,
      userRegisterConfig,
      map,
      onContextChange,
      onContextClear,
      parentOptionsList,
      childOptionsList,
      onParentChange,
      onParentClear,
      onChildClear,
    }
  },
})
</script>

<style lang="postcss" scoped>

</style>
